module.exports = "/assets/data/3b72bcde93232fc8417842961a85df47-CM77.data.json";